'use strict';
define([
    'angular',
    'modules/seochecker/results/structure/structure.controller'
], function (angular, SEOCheckerStructureController) {
    var app = angular.module('app.seochecker.results.structure', []);
    app.controller('SEOCheckerStructureController', SEOCheckerStructureController);
    return app;
});
